import logo from './logo.svg';
import './App.css';
import React, { Component, useCallback, useEffect, useState, useContext, Suspense, lazy } from 'react';
import MainNavigation from './components/Navigation/MainNavigation/MainNavigation';
import { trackRouteFallback } from './utils/prerenderHold';
import { BrowserRouter, Route, Redirect, Switch, useHistory, useLocation } from 'react-router-dom';
import authContext from './AuthContext/authContext';
import Colors from './constants/Colors';
import Cookies from 'js-cookie';
import { userLoginRegisterRequest, checkTokenQuery, updateUser, getUserSummary } from './components/Graph/Authentication/userAuth';
import {homeURL } from './codes';
import { Helmet, HelmetProvider } from 'react-helmet-async';
// import Dashboard from './components/Navigation/MainNavigation/Dashboard/Dashboard';
//import { loadUserSummary } from './components/Graph/Authentication/userAuth';
import { getForums } from './components/Graph/Authentication/posts';
import { getForumReplies } from './components/Graph/Authentication/postreplies';
import lazyRetry from './components/Navigation/MainNavigation/Utils/lazyRetry';

import WaitingModal from './components/Navigation/MainNavigation/Generic/WaitingModal';


const ProductKnowledgeCopilotRoot = lazy(() => import('./components/ProductKnowledgeCopilot/release'));
const ProductKnowledgeCopilotPage = lazy(() => import('./components/ProductKnowledgeCopilot/release').then((module) => ({ default: module.ProductKnowledgeCopilotPage })));

// const Colors = lazy(() => lazyRetry( () => import('./constants/Colors')));
// const Home = lazy(() => lazyRetry( () => import('./components/Navigation/MainNavigation/Home/Home')));
const Home2 = lazy(() => lazyRetry( () => import('./components/Navigation/MainNavigation/Home2/Home2')));
// Route-level, like every other page: the showcase route pulls in mediasfu-reactjs
// (and mediasoup-client), which would otherwise land in the initial bundle for
// every visitor, including the homepage.
const PricingDetails = lazy(() => lazyRetry( () => import('./components/Navigation/MainNavigation/Pricing/PricingDetails')));
const FamiliarChatCallParticipantRoute = lazy(() => lazyRetry( () => import('./components/Navigation/MainNavigation/SolutionCapsules/FamiliarChatCallParticipantRoute')));
const Demos = lazy(() => lazyRetry( () => import('./components/Navigation/MainNavigation/Demos/Demos')));
const Features = lazy(() => lazyRetry( () => import('./components/Navigation/MainNavigation/Features/FeaturesNew')));
//const Developers = lazy(() => lazyRetry( () => import('./components/Navigation/MainNavigation/Developers/Developers')));
const Pricing = lazy(() => lazyRetry( () => import('./components/Navigation/MainNavigation/Pricing/PricingNew')));
const Login = lazy(() => lazyRetry( () => import('./components/Navigation/MainNavigation/Authentication/User/Login')));
const Signup = lazy(() => lazyRetry( () => import('./components/Navigation/MainNavigation/Authentication/User/Signup')));
const ForgotPassword = lazy(() => lazyRetry( () => import('./components/Navigation/MainNavigation/Authentication/User/ForgotPassword')));

// const Dashboard = lazy(() => lazyRetry( () => import('./components/Navigation/MainNavigation/Dashboard/Dashboard')));
const DashboardRouter = lazy(() => lazyRetry( () => import('./components/Navigation/MainNavigation/Dashboard/DashboardRouter')));
const PlatformOperationsPage = lazy(() => lazyRetry(() => import('./components/Navigation/MainNavigation/Dashboard/PlatformOperationsPage')));
const WidgetStudioPublicPage = lazy(() => lazyRetry( () => import('./components/Navigation/MainNavigation/Dashboard/WidgetStudio/WidgetStudioPublicPage')));
const WidgetLab = lazy(() => lazyRetry( () => import('./components/Navigation/MainNavigation/WidgetLab/WidgetLab')));
/* TEMPORARY: landing-page opening variants for comparison. Dev-gated below.
   Delete this import and the /land1..3 routes once one is chosen. */
const LandingVariantPage = lazy(() => lazyRetry( () => import('./components/Navigation/MainNavigation/Home2/LandingVariantPage')));
const AIAgentsStudioPublicPage = lazy(() => lazyRetry( () => import('./components/Navigation/MainNavigation/AIAgentsStudio/AIAgentsStudioPublicPage')));
const VibeStudioPage = lazy(() => lazyRetry( () => import('./components/Navigation/MainNavigation/VibeStudio/VibeStudioPage')));
const PublicShowcasePage = lazy(() => lazyRetry( () => import('./components/Navigation/MainNavigation/SolutionCapsules/PublicShowcasePage')));
const SolutionCapsulesPage = lazy(() => lazyRetry( () => import('./components/Navigation/MainNavigation/SolutionCapsules/SolutionCapsulesPage')));
const CapsuleLivePage = lazy(() => lazyRetry( () => import('./components/Navigation/MainNavigation/SolutionCapsules/CapsuleLivePage')));
const Verify = lazy(() => lazyRetry( () => import('./components/Navigation/MainNavigation/Authentication/User/Verify')));
// const Chat = lazy(() => lazyRetry( () => import('./components/Navigation/MainNavigation/Events/Chat')));
const Forums = lazy(() => lazyRetry( () => import('./components/Navigation/MainNavigation/Home/Forum')));
const SubscriptionPage = lazy(() => lazyRetry( () => import('./components/Navigation/MainNavigation/Dashboard/Subscription/SubscriptionPage')));
const PaymentPage = lazy(() => lazyRetry( () => import('./components/Navigation/MainNavigation/Dashboard/Subscription/PaymentPage')));
const Purchase = lazy(() => lazyRetry( () => import('./components/Navigation/MainNavigation/Dashboard/Subscription/Purchase')));
const ClaimBenefits = lazy(() => lazyRetry( () => import('./components/Navigation/MainNavigation/Dashboard/Subscription/ClaimBenefits')));
const Support = lazy(() => lazyRetry( () => import('./components/Navigation/MainNavigation/Support/Support')));
const Recordings = lazy(() => lazyRetry( () => import('./components/Navigation/MainNavigation/Recording/Recordings')));
const AINotesPublic = lazy(() => lazyRetry( () => import('./components/Navigation/MainNavigation/AINotesPublic/AINotesPublic')));
const AINotesGuide = lazy(() => lazyRetry( () => import('./components/Navigation/MainNavigation/AINotesGuide/AINotesGuide')));
const Security = lazy(() => lazyRetry( () => import('./components/Navigation/MainNavigation/Foot/Security')));
const VideoCodecs = lazy(() => lazyRetry( () => import('./components/Navigation/MainNavigation/Foot/VideoCodecs')));
const Scaling = lazy(() => lazyRetry( () => import('./components/Navigation/MainNavigation/Foot/Scaling')));
const RecommendedSettings = lazy(() => lazyRetry( () => import('./components/Navigation/MainNavigation/Foot/RecommendedSettings')));
const AboutUs = lazy(() => lazyRetry( () => import('./components/Navigation/MainNavigation/Foot/AboutUs')));
const Careers = lazy(() => lazyRetry( () => import('./components/Navigation/MainNavigation/Foot/Careers')));
const MediaSFUPrebuilt = lazy(() => lazyRetry( () => import('./components/Navigation/MainNavigation/Foot/MediaSFUPrebuilt')));
const Streaming = lazy(() => lazyRetry( () => import('./components/Navigation/MainNavigation/Foot/Streaming')));
const PrivacyPolicy = lazy(() => lazyRetry( () => import('./components/Navigation/MainNavigation/Foot/PrivacyPolicy')));
const TermsOfService = lazy(() => lazyRetry( () => import('./components/Navigation/MainNavigation/Foot/TermsOfService')));
const APIKeys = lazy(() => lazyRetry( () => import('./components/Navigation/MainNavigation/Foot/APIKeys')));
const CloudRecording = lazy(() => lazyRetry( () => import('./components/Navigation/MainNavigation/Foot/CloudRecording')));
const DeleteAccount = lazy(() => lazyRetry( () => import('./components/Navigation/MainNavigation/Foot/DeleteAccount')));
const SubscriptionInfo = lazy(() => lazyRetry( () => import('./components/Navigation/MainNavigation/Dashboard/Subscription/SubcriptionInfo')));
const Sandbox = lazy(() => lazyRetry( () => import('./components/Navigation/MainNavigation/Sandbox/Sandbox')));
// const VideoCallSetup = lazy(() => lazyRetry( () => import('./components/Navigation/MainNavigation/MediaSFUDocs/VideoCallSetup')));
const AIPipelineGuide = lazy(() => lazyRetry( () => import('./components/Navigation/MainNavigation/AIPipelineGuide/AIPipelineGuide')));
const SIPConfigGuide = lazy(() => lazyRetry( () => import('./components/Navigation/MainNavigation/SIPConfigGuide/SIPConfigGuide')));
const TranslationGuide = lazy(() => lazyRetry( () => import('./components/Navigation/MainNavigation/TranslationGuide/TranslationGuide')));
const DisposableKeysGuide = lazy(() => lazyRetry( () => import('./components/Navigation/MainNavigation/DisposableKeysGuide/DisposableKeysGuide')));
const WidgetsGuide = lazy(() => lazyRetry( () => import('./components/Navigation/MainNavigation/WidgetsGuide/WidgetsGuide')));
const CampaignsGuide = lazy(() => lazyRetry( () => import('./components/Navigation/MainNavigation/CampaignsGuide/CampaignsGuide')));
const UserGuidesHub = lazy(() => lazyRetry( () => import('./components/Navigation/MainNavigation/UserGuidesHub/UserGuidesHub')));
const WidgetStudioGuide = lazy(() => lazyRetry( () => import('./components/Navigation/MainNavigation/WidgetStudioGuide/WidgetStudioGuide')));
const DashboardUserGuide = lazy(() => lazyRetry( () => import('./components/Navigation/MainNavigation/Docs/Docs')));
const DeveloperDocumentation = lazy(() => lazyRetry( () => import('./components/Navigation/MainNavigation/Documentation/Documentation')));
const MediaSFUCheatSheet = lazy(() => lazyRetry( () => import('./components/Navigation/MainNavigation/CheatCode/MediaSFUCheatSheet')));

// Meeting Interface (Modern MediaSFU)
const MeetingInterface = lazy(() => lazyRetry( () => import('./media/MeetingInterface')));

// LiteDashboard (B2C Consumer Dashboard)
const LiteDashboard = lazy(() => lazyRetry( () => import('./components/Navigation/MainNavigation/LiteDashboard/LiteDashboard')));
// AgentsDashboard (standalone AI agents workspace — peer of /lite and /dashboard)
const AgentsDashboard = lazy(() => lazyRetry( () => import('./components/Navigation/MainNavigation/AgentsDashboard/AgentsDashboard')));
const LiteSubscriptionPage = lazy(() => lazyRetry( () => import('./components/Navigation/MainNavigation/LiteDashboard/LiteSubscriptionPage')));
const TopUpPage = lazy(() => lazyRetry( () => import('./components/Navigation/MainNavigation/LiteDashboard/TopUpPage')));

// Products Page and Individual Product Pages
const Products = lazy(() => lazyRetry( () => import('./components/Navigation/MainNavigation/Products/Products')));
const MeetingsProduct = lazy(() => lazyRetry( () => import('./components/Navigation/MainNavigation/Products/MeetingsProduct')));
const VoiceProduct = lazy(() => lazyRetry( () => import('./components/Navigation/MainNavigation/Products/VoiceProduct')));
const LiveProduct = lazy(() => lazyRetry( () => import('./components/Navigation/MainNavigation/Products/LiveProduct')));
const AgentsProduct = lazy(() => lazyRetry( () => import('./components/Navigation/MainNavigation/Products/AgentsProduct')));
const TranslateProduct = lazy(() => lazyRetry( () => import('./components/Navigation/MainNavigation/Products/TranslateProduct')));

// Solutions Page and Individual Solution Pages
const Solutions = lazy(() => lazyRetry( () => import('./components/Navigation/MainNavigation/Solutions/Solutions')));
const RemoteTeamsSolution = lazy(() => lazyRetry( () => import('./components/Navigation/MainNavigation/Solutions/RemoteTeamsSolution')));
const CallCentersSolution = lazy(() => lazyRetry( () => import('./components/Navigation/MainNavigation/Solutions/CallCentersSolution')));
const EdTechSolution = lazy(() => lazyRetry( () => import('./components/Navigation/MainNavigation/Solutions/EdTechSolution')));
const EventsSolution = lazy(() => lazyRetry( () => import('./components/Navigation/MainNavigation/Solutions/EventsSolution')));
const LiveCommerceSolution = lazy(() => lazyRetry( () => import('./components/Navigation/MainNavigation/Solutions/LiveCommerceSolution')));
const DevelopersSolution = lazy(() => lazyRetry( () => import('./components/Navigation/MainNavigation/Solutions/DevelopersSolution')));
const HealthcareSolution = lazy(() => lazyRetry( () => import('./components/Navigation/MainNavigation/Solutions/HealthcareSolution')));
const BlogList = lazy(() => lazyRetry( () => import('./components/Navigation/MainNavigation/Blog/BlogList')));
const NotFound = lazy(() => lazyRetry( () => import('./components/Navigation/MainNavigation/NotFound/NotFound')));
const BlogDetail = lazy(() => lazyRetry( () => import('./components/Navigation/MainNavigation/Blog/BlogDetail')));
const BlogAdmin = lazy(() => lazyRetry( () => import('./components/Navigation/MainNavigation/Blog/BlogAdmin')));
const UseCasesHubPage = lazy(() => lazyRetry( () => import('./components/Navigation/MainNavigation/UseCases/UseCasesHubPage')));
const SDKUseCaseShowcase = lazy(() => lazyRetry( () => import('./components/Navigation/MainNavigation/UseCases/SDKUseCaseShowcase')));
const AIMethodRuntimeOverrideReferencePage = lazy(() => lazyRetry( () => import('./components/Navigation/MainNavigation/Docs/AIMethodRuntimeOverrideReferencePage')));
const ZeroCodeAIAgentsPage = lazy(() => lazyRetry( () => import('./components/Navigation/MainNavigation/UseCases/ZeroCodeAIAgentsPage')));
const LiveVoiceWebinarPage = lazy(() => lazyRetry( () => import('./components/Navigation/MainNavigation/UseCases/LiveVoiceWebinarPage')));
const CaseStudiesHubPage = lazy(() => lazyRetry( () => import('./components/Navigation/MainNavigation/UseCases/CaseStudiesHubPage')));
const CaseStudySaaSSupportPage = lazy(() => lazyRetry( () => import('./components/Navigation/MainNavigation/UseCases/CaseStudySaaSSupportPage')));
const CaseStudyMultilingualWebinarPage = lazy(() => lazyRetry( () => import('./components/Navigation/MainNavigation/UseCases/CaseStudyMultilingualWebinarPage')));
const TopicAuthorityPage = lazy(() => lazyRetry( () => import('./components/Navigation/MainNavigation/UseCases/TopicAuthorityPage')));
const WebRTCAuthorityPage = lazy(() => lazyRetry( () => import('./components/Navigation/MainNavigation/UseCases/WebRTCAuthorityPage')));
const VsHubPage = lazy(() => lazyRetry( () => import('./components/Navigation/MainNavigation/UseCases/VsHubPage')));
const VsVapiPage = lazy(() => lazyRetry( () => import('./components/Navigation/MainNavigation/UseCases/VsVapiPage')));
const VsBlandPage = lazy(() => lazyRetry( () => import('./components/Navigation/MainNavigation/UseCases/VsBlandPage')));
const VsRetellPage = lazy(() => lazyRetry( () => import('./components/Navigation/MainNavigation/UseCases/VsRetellPage')));
const VsTwilioPage = lazy(() => lazyRetry( () => import('./components/Navigation/MainNavigation/UseCases/VsTwilioPage')));
const VsAgoraPage = lazy(() => lazyRetry( () => import('./components/Navigation/MainNavigation/UseCases/VsAgoraPage')));
const VsDailyPage = lazy(() => lazyRetry( () => import('./components/Navigation/MainNavigation/UseCases/VsDailyPage')));
const VsPipecatPage = lazy(() => lazyRetry( () => import('./components/Navigation/MainNavigation/UseCases/VsPipecatPage')));
const VsLivekitPage = lazy(() => lazyRetry( () => import('./components/Navigation/MainNavigation/UseCases/VsLivekitPage')));
const VsVonagePage = lazy(() => lazyRetry( () => import('./components/Navigation/MainNavigation/UseCases/VsVonagePage')));
const AlternativesPage = lazy(() => lazyRetry( () => import('./components/Navigation/MainNavigation/UseCases/AlternativesPage')));
const DownloadPage = lazy(() => lazyRetry( () => import('./components/Navigation/MainNavigation/Download/DownloadPage')));

const GoogleAnalyticsScripts = ({ trackingId }) => (
  <HelmetProvider>
   <Helmet>
    <script async src={`https://www.googletagmanager.com/gtag/js?id=${trackingId}`}></script>
    <script>
      {`
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());
        gtag('config', '${trackingId}');
        (window.__msfuEvents || []).forEach(function (e) { gtag('event', e[0], e[1]); });
        window.__msfuEvents = [];
      `}
    </script>
  </Helmet>
  </HelmetProvider>
);

const GoogleAnalyticsTag = ({ trackingId }) => {
  const [enabled, setEnabled] = useState(false);

  useEffect(() => {
    if (typeof window === 'undefined') return undefined;

    let idleId;
    let timerId;
    let armed = true;
    const interactionEvents = ['pointerdown', 'keydown'];

    const enable = () => {
      if (!armed) return;
      armed = false;
      setEnabled(true);
      interactionEvents.forEach((eventName) => {
        window.removeEventListener(eventName, enable);
      });
    };

    const schedule = () => {
      if ('requestIdleCallback' in window) {
        idleId = window.requestIdleCallback(enable, { timeout: 5000 });
      } else {
        timerId = window.setTimeout(enable, 3500);
      }
    };

    interactionEvents.forEach((eventName) => {
      window.addEventListener(eventName, enable, { once: true, passive: true });
    });

    if (document.readyState === 'complete') {
      schedule();
    } else {
      window.addEventListener('load', schedule, { once: true });
    }

    return () => {
      armed = false;
      window.removeEventListener('load', schedule);
      interactionEvents.forEach((eventName) => {
        window.removeEventListener(eventName, enable);
      });
      if (idleId && 'cancelIdleCallback' in window) window.cancelIdleCallback(idleId);
      if (timerId) window.clearTimeout(timerId);
    };
  }, []);

  return enabled ? <GoogleAnalyticsScripts trackingId={trackingId} /> : null;
};

const shouldHandleClientSideRoute = (url) => {
  const pathname = url?.pathname || '';
  if (!pathname.startsWith('/')) return false;
  if (pathname === '/signout') return false;
  if (pathname === '/docs' || pathname.startsWith('/docs/')) return false;
  if (pathname === '/storybook' || pathname.startsWith('/storybook/')) return false;

  // Keep native navigation for static assets/downloads like .html/.zip/.pdf
  const hasLikelyFileExtension = /\.[a-z0-9]{2,8}$/i.test(pathname);
  if (hasLikelyFileExtension) return false;

  return true;
};

const InternalLinkInterceptor = () => {
  const history = useHistory();

  useEffect(() => {
    const handleDocumentClick = (event) => {
      const isPrimaryClick = typeof event.button !== 'number' || event.button === 0;
      if (event.defaultPrevented || !isPrimaryClick) return;
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

      const clickTarget = event.target;
      const targetElement = clickTarget instanceof Element ? clickTarget : clickTarget?.parentElement;
      if (!(targetElement instanceof Element)) return;

      const anchor = targetElement.closest('a[href]');
      if (!anchor) return;
      if (anchor.hasAttribute('download')) return;

      const target = (anchor.getAttribute('target') || '').toLowerCase();
      if (target && target !== '_self') return;

      const rawHref = anchor.getAttribute('href') || '';
      if (!rawHref) return;
      if (rawHref.startsWith('#')) return;
      if (rawHref.startsWith('mailto:') || rawHref.startsWith('tel:') || rawHref.startsWith('javascript:')) {
        return;
      }

      let resolvedUrl;
      try {
        resolvedUrl = new URL(rawHref, window.location.origin);
      } catch {
        return;
      }

      if (resolvedUrl.origin !== window.location.origin) return;
      if (!shouldHandleClientSideRoute(resolvedUrl)) return;

      const nextPath = `${resolvedUrl.pathname}${resolvedUrl.search}${resolvedUrl.hash}`;
      const currentPath = `${window.location.pathname}${window.location.search}${window.location.hash}`;
      if (nextPath === currentPath) return;

      event.preventDefault();
      history.push(nextPath);
    };

    document.addEventListener('click', handleDocumentClick);
    return () => document.removeEventListener('click', handleDocumentClick);
  }, [history]);

  return null;
};

const matchesPathPrefix = (pathname = '', prefix = '') => (
  pathname === prefix || pathname.startsWith(`${prefix}/`)
);

const shouldHidePublicNavigation = (pathname = '') => {
  const hiddenPrefixes = [
    '/meeting',
    // '/lite',
    // '/litesubscription',
    // '/litetopup',
  ];

  return hiddenPrefixes.some((prefix) => matchesPathPrefix(pathname, prefix));
};

// Defined at module scope: a component declared inside App is a new type on
// every App render, so React would remount the whole navigation each time.
const ConditionalNavigation = () => {
  const location = useLocation();
  return shouldHidePublicNavigation(location.pathname) ? null : <MainNavigation />;
};

const PrerenderRouteStamp = () => {
  const location = useLocation();

  return (
    <span
      data-mediasfu-prerender-path={location.pathname}
      hidden
      aria-hidden="true"
    />
  );
};

const RouteTransitionFallback = () => {
  const location = useLocation();
  const isWorkspaceRoute = shouldHidePublicNavigation(location.pathname);

  // While the prerendered page is still on screen, this fallback stays hidden
  // behind it; the page is swapped out when real content replaces the fallback.
  React.useLayoutEffect(() => trackRouteFallback(), []);

  return (
    <div
      style={{
        minHeight: '100vh',
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'radial-gradient(circle at top, #1e293b 0%, #0f172a 45%, #020617 100%)',
        color: '#f8fafc',
        position: 'relative',
        overflow: 'hidden',
      }}
      aria-live="polite"
      aria-busy="true"
    >
      <style>{`
        /* An indeterminate bar rather than a spinner: a spinner reads as
           "blocked", a travelling bar reads as "assembling". It animates
           transform only, so it composites on the GPU and costs nothing on a
           weak device — which matters here, because this is the first thing a
           cold start renders. */
        @keyframes appRouteTrack {
          0%   { transform: translateX(-100%) scaleX(0.4); }
          50%  { transform: translateX(0%) scaleX(0.65); }
          100% { transform: translateX(100%) scaleX(0.4); }
        }

        /* Held back for 300ms: most route loads (and a prefetched dashboard)
           finish before then, and a card that flashes up and away reads as
           jank rather than progress. Slow loads still get it. */
        @keyframes appRouteReveal {
          from { opacity: 0; transform: translateY(6px); }
          to { opacity: 1; transform: none; }
        }

        @keyframes appRouteBreathe {
          0%, 100% { opacity: 0.7; }
          50% { opacity: 1; }
        }

        @media (prefers-reduced-motion: reduce) {
          .app-route-bar { animation: none !important; transform: none !important; }
          .app-route-mark { animation: none !important; }
          .app-route-card { animation: none !important; }
        }
      `}</style>

      <div
        style={{
          position: 'absolute',
          inset: 0,
          background: 'radial-gradient(circle at 20% 20%, rgba(59, 130, 246, 0.16), transparent 32%), radial-gradient(circle at 80% 80%, rgba(14, 165, 233, 0.14), transparent 28%)',
          pointerEvents: 'none',
        }}
      />

      <div
        className="app-route-card"
        style={{
          animation: 'appRouteReveal 220ms ease-out 300ms both',
          position: 'relative',
          zIndex: 1,
          width: 'min(420px, calc(100vw - 32px))',
          padding: '30px 30px 26px',
          borderRadius: '16px',
          background: 'rgba(15, 23, 42, 0.92)',
          border: '1px solid rgba(94, 234, 212, 0.22)',
          /* The site's solid offset treatment, so the very first screen already
             looks like the pages behind it. */
          boxShadow: '10px 10px 0 rgba(20, 163, 148, 0.28)',
          textAlign: 'left',
        }}
      >
        <div
          className="app-route-mark"
          style={{
            fontSize: '0.72rem',
            fontWeight: 800,
            letterSpacing: '0.16em',
            textTransform: 'uppercase',
            color: '#5eead4',
            marginBottom: '14px',
            animation: 'appRouteBreathe 2.4s ease-in-out infinite',
          }}
        >
          MediaSFU
        </div>

        <h2
          style={{
            margin: 0,
            fontSize: '1.15rem',
            fontWeight: 700,
            color: '#f8fafc',
          }}
        >
          {isWorkspaceRoute ? 'Opening your workspace...' : 'Loading page...'}
        </h2>

        <p
          style={{
            margin: '10px 0 0',
            fontSize: '0.92rem',
            lineHeight: 1.6,
            color: '#94a3b8',
          }}
        >
          {isWorkspaceRoute
            ? 'This may take a moment if you have a cold start. Don\'t worry, your workspace will be ready soon.'
            : 'Preparing the next screen.'}
        </p>

        <div
          style={{
            marginTop: '20px',
            height: '3px',
            borderRadius: '999px',
            background: 'rgba(148, 163, 184, 0.16)',
            overflow: 'hidden',
          }}
        >
          <div
            className="app-route-bar"
            style={{
              width: '100%',
              height: '100%',
              borderRadius: '999px',
              background: 'linear-gradient(90deg, transparent, #5eead4, #14a394, transparent)',
              animation: 'appRouteTrack 1.6s ease-in-out infinite',
            }}
          />
        </div>
      </div>
    </div>
  );
};

const NativeRouteRedirect = ({ to, fallback }) => {
  useEffect(() => {
    if (typeof window !== 'undefined') {
      // Loop guard: if we've already tried a native redirect to this URL within
      // the same session and landed back on the React SPA, the server is not
      // serving a different page there.  Fall back to the in-app route instead.
      const loopKey = `_nrr_${to}`;
      if (sessionStorage.getItem(loopKey)) {
        sessionStorage.removeItem(loopKey);
        if (fallback && fallback !== to) {
          window.location.replace(fallback);
        }
        return;
      }
      sessionStorage.setItem(loopKey, '1');
      window.location.replace(to);
    }
  }, [to, fallback]);

  return null;
};

function App() {

  const KeyLess = process.env.REACT_APP_KEYLESS;

  //check current url and set active link

  // Determine if the current route should hide the footer
  
  const [isFooterHidden, setIsFooterHidden] = useState(false);

  const [token, setToken] = useState(Cookies.get('token'))
  const [userId, setUserId] = useState(Cookies.get('userId'))
  const [username, setUsername] = useState(Cookies.get('username'))
  const [email, setEmail] = useState(Cookies.get('email'))
  const [tempRole, setTempRole] = useState(Cookies.get('tempRole'))
  const [tempUsername, setTempUsername] = useState(Cookies.get('tempUsername'))
  const [tempEmail, setTempEmail] = useState(Cookies.get('tempEmail'))
  const [meetingRoomData, setMeetingRoomData] = useState(null)
  const [eventType, setEventType] = useState("")

  const [forget, setForget] = useState(null)
  const [signup, setSignup] = useState(null)
  const [reset, setReset] = useState(false)
  const [reset_token, setReset_token] = useState("")
  const [reset_pass, setReset_pass] = useState(false)
  const [isVerified, setIsVerified] = useState(Cookies.get('isVerified') === 'true' || Cookies.get('isVerified') === true);
  const [role, setRole] = useState(Cookies.get('role') ? Cookies.get('role') : 'child')
  const [forumsData, setForumsData] = useState(null)
  const [repliesData, setRepliesData] = useState(null)

  const [summaryData, setSummaryData] = useState(Cookies.get('summaryData') ? JSON.parse(Cookies.get('summaryData')) : null)

  const updateSummaryData = (summaryData_) => {

    setSummaryData(summaryData_);
    let tokenExpiration = new Date(new Date().getTime() + 3600 * 1000);
    try {
      Cookies.set('summaryData', JSON.stringify(summaryData_), { expires: tokenExpiration });
    } catch (error) {

    }


  }

  let RequestingReplies = false;
  let RequestingForums = false;

  const [modalActive, setModalActive] = useState(false);

  // Memoised: these are passed into pages that list them as effect dependencies.
  // As plain functions they got a new identity on every App render, so an effect
  // that called one of them re-triggered itself forever — visible as the loading
  // modal flickering (notably on /purchase).
  const startLoading = useCallback(() => {
    setModalActive(true);
  }, []);

  const stopLoading = useCallback(() => {
    setModalActive(false);
  }, []);
  
  const [canSubscribe, setCanSubscribe] = useState(false);
  const [currentSubscription, setCurrentSubscription] = useState(null);
  const [currentValidSubscription, setCurrentValidSubscription] = useState(null);

  const updateSubscription = (canSubscribe_, currentSubscription_,currentValidSubscription_) => {
    setCanSubscribe(canSubscribe_);
    setCurrentSubscription(currentSubscription_);
    setCurrentValidSubscription(currentValidSubscription_);
    Cookies.set('canSubscribe', canSubscribe_, { expires: 1 });
    Cookies.set('currentSubscription', currentSubscription_, { expires: 1 });
    Cookies.set('currentValidSubscription', currentValidSubscription_, { expires: 1 });
  }

  const [authdatainfo, setAuthdatainfo] = useState('')
  const [attemptauth, setAttemptauth] = useState(false)

  const setauthattempts = (authdatainfo, attemptauth) => {

    setAuthdatainfo(JSON.stringify(authdatainfo))
    setAttemptauth(attemptauth)
  }

  const resetswitch = (reset_pass) => {
    setReset_pass(reset_pass);

  }

  const [mainScreen, setMainScreen] = useState(null)


  const [res_email, setRes_email] = useState(null)
  const [res_phone, setRes_phone] = useState(null)

  const [isloading, setIsloading] = useState(false)

  const setmainscreen = (mainScreen) => {
    setMainScreen(mainScreen);
  }

  const setload = (isloading) => {
    setIsloading(isloading);
  }

  const updateVerified = (verified) => {
    setIsVerified(verified);
    let tokenExpiration = new Date(new Date().getTime() + 3600 * 1000);
    Cookies.set('isVerified', verified, { expires: tokenExpiration });
  }

  // Memoised for the same reason as startLoading/stopLoading: pages call login()
  // inside an effect that also depends on it. An unstable identity made that
  // effect loop indefinitely. Only stable setters and Cookies are used, so an
  // empty dependency list is correct here.
  const login = useCallback((token, userId, name, tokenExpiration, verified, email, role) => {

    setToken(token)
    setUserId(userId)
    setUsername(name)
    setIsVerified(verified)
    setEmail(email)
    setRole(role)
    tokenExpiration = new Date(new Date().getTime() + 3600 * 1000);
    Cookies.set('token', token, { expires: tokenExpiration });
    Cookies.set('userId', userId, { expires: tokenExpiration });
    Cookies.set('username', name, { expires: tokenExpiration });
    Cookies.set('isVerified', verified, { expires: tokenExpiration });
    Cookies.set('email', email, { expires: tokenExpiration });
    Cookies.set('tokenExpiration', tokenExpiration, { expires: tokenExpiration });
    Cookies.set('role', role, { expires: tokenExpiration });
  }, [])

  const authswitch = (forget, signup, reset) => {
    setForget(forget)
    setSignup(signup)
    setReset(reset)
  }

  const authdetails = (res_email, res_phone, reset_token) => {
    setRes_email(res_email)
    setRes_phone(res_phone)
    setReset_token(reset_token)
  }

  const updateMeetingRoomData = (meetingRoomData_) => {
    setMeetingRoomData(meetingRoomData_)
  }

  const updateEventType = (eventType_) => {
    setEventType(eventType_)
  }

  const switchAccount = async (usernamed, emailed, option = true, updateOnly = false, rolez = "") => {
    let tokenExpiration = new Date(new Date().getTime() + 3600 * 1000);

    if (updateOnly) {
      //confirm switch to new user and seeting as new user (logged-in user)
      await Cookies.set('email', emailed, { expires: tokenExpiration });
      await Cookies.set('username', usernamed, { expires: tokenExpiration });
      await Cookies.set('role', rolez, { expires: tokenExpiration });


      setUsername(usernamed)
      setEmail(emailed)
      setRole(rolez)
      return true
    }

    if (option) {

      //keeping the old user details in temp

      await setTempEmail(email)
      await setTempRole(role)
      await setTempUsername(username)


      await Cookies.set('tempRole', role, { expires: tokenExpiration });
      await Cookies.set('tempUsername', username, { expires: tokenExpiration });
      await Cookies.set('tempEmail', email, { expires: tokenExpiration });

    } else {

      await setRole(tempRole ? tempRole : Cookies.get('tempRole'))
      await setUsername(tempUsername ? tempUsername : Cookies.get('tempUsername'))
      await setEmail(tempEmail ? tempEmail : Cookies.get('tempEmail'))
      let tokenExpiration = new Date(new Date().getTime() + 3600 * 1000);

      await Cookies.set('role', tempRole ? tempRole : Cookies.get('tempRole'), { expires: tokenExpiration });
      await Cookies.set('username', tempUsername ? tempUsername : Cookies.get('tempUsername'), { expires: tokenExpiration });
      await Cookies.set('email', tempEmail ? tempEmail : Cookies.get('tempEmail'), { expires: tokenExpiration });

      usernamed = tempUsername ? tempUsername : Cookies.get('tempUsername')
      emailed = tempEmail ? tempEmail : Cookies.get('tempEmail')

      await Cookies.remove('tempRole');
      await Cookies.remove('tempUsername');
      await Cookies.remove('tempEmail');

      //set the temp user details to the new user details
      await setTempEmail(null)
      await setTempRole(null)
      await setTempUsername(null)

    }

    startLoading();

    try {
      findUserInput.username = usernamed;
      findUserInput.email = emailed;
      let success = await loadUserSummary(findUserInput);
      stopLoading();
      if (success) {
        return true
      } else {
        return false
      }
    } catch (error) {
   
      stopLoading();
      return false
    }


  }


  const logout = () => {
    setToken(null)
    setUserId(null)
    setUsername(null)
    Cookies.remove('token');
    Cookies.remove('userId');
    Cookies.remove('username');
    Cookies.remove('isVerified');
    Cookies.remove('email');
    Cookies.remove('tokenExpiration');
    Cookies.remove('role');
    Cookies.remove('summaryData');
    Cookies.remove('tempRole');
    Cookies.remove('tempUsername');
    Cookies.remove('tempEmail');
    Cookies.remove('canSubscribe');
    Cookies.remove('currentSubscription');
    Cookies.remove('currentValidSubscription');

    //reset the state variables
    setToken(null)
    setUserId(null)
    setUsername(null)
    setIsVerified(false)
    setEmail(null)
    setRole(null)
  }


  const prefersDarkMode = window.matchMedia('(prefers-color-scheme: dark)').matches;

  const bodyColor = prefersDarkMode ? 'dark' : 'light';
  const black = Colors[bodyColor].text;
  const white = Colors[bodyColor].background;

  const calor = white;


  const stylee = bodyColor != "light" ? "light" : "dark"

  let getForumsInput = {
    startIndex: 0,
    pageSize: 4
  }

  let getForumRepliesInput = {
    startIndex: 0,
    pageSize: 4
  }

  //  const windowHeight = Dimensions.get('window').height;
  const windowHeight = 1000;
  const decHeight = Math.round(0.1 * windowHeight);
  homeURL = process.env.REACT_APP_MODE === 'Dev' ? process.env.REACT_APP_HOMEURL_TEST : process.env.REACT_APP_HOMEURL;
  const url =  homeURL 
  


  async function loadReplies(getForumRepliesInput, checking) {

    let baseUrl = url;

    try {

      if (!getForumRepliesInput.post) {
        return false
      }

      let requestBody = await getForumReplies(getForumRepliesInput, false, 'noKey');

      const resData = await userLoginRegisterRequest(requestBody, baseUrl);


      if (typeof resData === 'string' || resData instanceof String) {

        return false

      } else {

        if (checking && resData.data.postReplies_specific.length == 0) {
          return false
        } else {
          setRepliesData(await resData.data.postReplies_specific);
          return true
        }

      }

    } catch (error) {

      return false
    }
  }


  async function loadForums(getForumsInput, checking) {
    let baseUrl = url;

    try {


      // if (!getForumsInput.username){
      //   getForumsInput.username = Cookies.get('username') ? Cookies.get('username') : null
      // }

      if (!getForumsInput.username) {
        getForumsInput.username = '1234567'
      }

      let requestBody = await getForums(getForumsInput, false, 'noKey');

      const resData = await userLoginRegisterRequest(requestBody, baseUrl);


      if (typeof resData === 'string' || resData instanceof String) {

        return false

      } else {
        if (checking && resData.data.posts_specific.length == 0) {
          return false
        } else {
          setForumsData(await resData.data.posts_specific);
          return true
        }
      }

    } catch (error) {

      return false
    }
  }


  let findUserInput = {
    username: Cookies.get('username'),
    email: Cookies.get('email')
  }


  async function loadUserSummary(findRoomUserInput) {
    let baseUrl = url;

    try {
      let requestBody = await getUserSummary(findRoomUserInput, true, KeyLess);
      const resData = await userLoginRegisterRequest(requestBody, baseUrl);

      if (typeof resData === 'string' || resData instanceof String) {
        return false
      } else {

        setSummaryData(await resData.data.getUserSummary);
        return true
      }
    } catch (error) {
      return false
    }

  }

  const refreshPage = () => {
    const findUserInput = {
      username: Cookies.get('username'),
      email: Cookies.get('email'),
    }

    startLoading();
    loadUserSummary(findUserInput);
    stopLoading();
  }


  const loadAllForums = async () => {

    if (forumsData == null && !RequestingForums) {
      RequestingForums = true;
      await loadForums(getForumsInput);
      RequestingForums = false;
    }
  }

  useEffect(() => {
    loadAllForums();
  }, []);

  useEffect(() => {

    if (summaryData == null) {

      if (Cookies.get('username') && Cookies.get('email')) {

        findUserInput.username = Cookies.get('username');
        findUserInput.email = Cookies.get('email');


        loadUserSummary(findUserInput);
      }
    }
  }, []);

  // ============ FLUTTER TOKEN AUTO-LOGIN ============
  // Handle token-based auto-login from Flutter app
  useEffect(() => {
    const handleFlutterTokenLogin = async () => {
      // Try to get params from search string first, then from hash (in case of hash routing)
      let urlParams = new URLSearchParams(window.location.search);
      let tokenParam = urlParams.get('token');
      let source = urlParams.get('source');
      
      // If not found in search, check if params are in the hash (hash router scenario)
      if (!tokenParam && window.location.hash) {
        const hashParts = window.location.hash.split('?');
        if (hashParts.length > 1) {
          urlParams = new URLSearchParams(hashParts[1]);
          tokenParam = urlParams.get('token');
          source = urlParams.get('source');
        }
      }
      
      // Also check if the full href contains the token (fallback parsing)
      if (!tokenParam && window.location.href.includes('token=')) {
        const hrefUrl = new URL(window.location.href);
        tokenParam = hrefUrl.searchParams.get('token');
        source = hrefUrl.searchParams.get('source');
      } 

      // Only process if coming from Flutter app with a token
      if (tokenParam && source === 'flutter_app') {
        try {
          // Validate token with backend - returns user details
          const requestBody = await checkTokenQuery(tokenParam);
          const resData = await userLoginRegisterRequest(requestBody, url);

          if (resData && resData.data && resData.data.checkToken) {
            const userData = resData.data.checkToken;

            // Token is valid and user details returned
            if (userData.status && userData.token && userData.userId) {
              const tokenExpiration = new Date(new Date().getTime() + 3600 * 1000);
              
              // Set cookies with backend-returned user details
              Cookies.set('token', userData.token, { expires: tokenExpiration });
              Cookies.set('userId', userData.userId, { expires: tokenExpiration });
              Cookies.set('username', userData.username, { expires: tokenExpiration });
              Cookies.set('email', userData.email, { expires: tokenExpiration });
              Cookies.set('isVerified', userData.isVerified, { expires: tokenExpiration });
              Cookies.set('role', userData.role, { expires: tokenExpiration });

              // Update React state
              setToken(userData.token);
              setUserId(userData.userId);
              setUsername(userData.username);
              setEmail(userData.email);
              setIsVerified(userData.isVerified);
              setRole(userData.role);

              // Also fetch user summary to populate liteType, isLiteUser etc.
              try {
                const summaryRequest = await getUserSummary({ username: userData.username, email: userData.email }, true, KeyLess);
                const summaryRes = await userLoginRegisterRequest(summaryRequest, url);
                if (summaryRes?.data?.getUserSummary) {
                  const summary = summaryRes.data.getUserSummary;
                  if (summary.liteType) Cookies.set('liteType', summary.liteType, { expires: 365 });
                  if (summary.isLiteUser !== undefined) Cookies.set('isLiteUser', summary.isLiteUser.toString(), { expires: 365 });
                  Cookies.set('summaryData', JSON.stringify(summary), { expires: tokenExpiration });
                }
              } catch (summaryErr) {
                // Non-critical - subscription page can still work
              }

              // Clean URL (remove token from URL for security)
              const cleanUrl = new URL(window.location.href);
              cleanUrl.searchParams.delete('token');
              cleanUrl.searchParams.delete('source');
              window.history.replaceState({}, '', cleanUrl.toString());
            }
          }
        } catch (error) {
          // Token invalid or expired - user will need to login manually
          // Clean URL anyway
          const cleanUrl = new URL(window.location.href);
          cleanUrl.searchParams.delete('token');
          cleanUrl.searchParams.delete('source');
          window.history.replaceState({}, '', cleanUrl.toString());
        }
      }
    };

    handleFlutterTokenLogin();
  }, []); // Run once on mount
  // ============ END FLUTTER TOKEN AUTO-LOGIN ============

  return (
    <HelmetProvider>
    <BrowserRouter>
      {process.env.REACT_APP_MODE === 'Prod' && <GoogleAnalyticsTag trackingId="G-M72BD91GHM" />}
      <PrerenderRouteStamp />
      <InternalLinkInterceptor />
      <Suspense fallback={<RouteTransitionFallback />}>
      <React.Fragment>
        <authContext.Provider value={{
          token: token, userId: userId, username: username, email: email, login: login, logout: logout, forget: forget, signup: signup, authswitch: authswitch,
          baseUrl: url, reset: reset, res_email: res_email, res_phone: res_phone, authdetails: authdetails, reset_token: reset_token, black: black,
          white: white, decHeight: decHeight, isloading: isloading, setload: setload, reset_pass: reset_pass, resetswitch: resetswitch, authdatainfo: authdatainfo, attemptauth:
            attemptauth, setauthattempts: setauthattempts, mainScreen: mainScreen, setMainScreen: setmainscreen, isVerified: isVerified, updateVerified: updateVerified, role: role, setRole: setRole,
          updateSummaryData: updateSummaryData, summaryData: summaryData, tempRole: tempRole, switchAccount: switchAccount, tempUsername: tempUsername,meetingRoomData: meetingRoomData, updateMeetingRoomData: updateMeetingRoomData,
          tempEmail: tempEmail, canSubscribe: canSubscribe, currentSubscription: currentSubscription, updateSubscription: updateSubscription, currentValidSubscription: currentValidSubscription, updateEventType: updateEventType, eventType: eventType,
        }}>
          <ConditionalNavigation />
          <main className="main-content">
      
            <Switch>
              <Route path="/" exact render={(props) => <Home2 WaitingModal={WaitingModal} {...props} />} />
              <Route path="/home" exact render={(props) => <Home2 WaitingModal={WaitingModal} {...props} />} />
              <Route path="/demos" exact component={Demos} />
              <Route path="/features" exact component={Features} />
              
              {/* Products routes */}
              <Route path="/products" exact component={Products} />
              <Route path="/products/meetings" exact component={MeetingsProduct} />
              <Route path="/products/voice" exact component={VoiceProduct} />
              <Route path="/products/live" exact component={LiveProduct} />
              <Route path="/products/agents" exact component={AgentsProduct} />
              <Route path="/products/translate" exact component={TranslateProduct} />
              
              {/* Solutions routes */}
              <Route path="/solutions" exact component={Solutions} />
              <Route path="/solutions/remote-teams" exact component={RemoteTeamsSolution} />
              <Route path="/solutions/call-centers" exact component={CallCentersSolution} />
              <Route path="/solutions/edtech" exact component={EdTechSolution} />
              <Route path="/solutions/events" exact component={EventsSolution} />
              <Route path="/solutions/live-commerce" exact component={LiveCommerceSolution} />
              <Route path="/solutions/developers" exact component={DevelopersSolution} />
              <Route path="/solutions/healthcare" exact component={HealthcareSolution} />
              
              {/* <Route path="/developers" exact component={Developers} /> */}
              <Route path="/pricing" exact component={Pricing} />
              <Route path="/pricing-details" exact component={PricingDetails} />
                {/* <Route path="/pricing" exact render={(props) => <Forums  {...props} />} /> */}
              <Route path="/forums" exact render={(props) => <Forums summaryData={summaryData} ForumsData={forumsData} RepliesData={repliesData} username={username} stopLoading={stopLoading} startLoading={startLoading} getForums={loadForums} getReplies={loadReplies} refreshPage={refreshPage} {...props} />} />
              <Route path="/forums/post/:postId" exact render={(props) => <Forums summaryData={summaryData} ForumsData={forumsData} RepliesData={repliesData} username={username} stopLoading={stopLoading} startLoading={startLoading} getForums={loadForums} getReplies={loadReplies} refreshPage={refreshPage} {...props} />} />
              {/* <Route path="/pricing" exact render={(props) => <Forums ForumsData={forumsData} username={username} stopLoading={stopLoading} startLoading={startLoading} getForums={loadForums} getReplies={loadReplies} {...props} />} /> */}
              {/* Dashboard route - uses DashboardRouter to conditionally render B2B or B2C dashboard */}
              <Route path="/dashboard" exact render={(props) => <DashboardRouter {...props} startLoading={startLoading} stopLoading={stopLoading} />} />
              <Route path="/dashboard/platform-operations" exact component={PlatformOperationsPage} />
              <Route
                path="/widget-studio"
                exact
                render={() => <WidgetStudioPublicPage username={username} />}
              />
              <Route
                path="/widgets-studio"
                exact
                render={() => <WidgetStudioPublicPage username={username} />}
              />
              <Route path="/vibe-studio" exact component={VibeStudioPage} />
              <Route path="/showcase-live" exact component={FamiliarChatCallParticipantRoute} />
              <Route path="/showcases" exact component={PublicShowcasePage} />
              <Route path="/showcases/:showcaseId" exact component={PublicShowcasePage} />
              {process.env.REACT_APP_MODE === 'Dev' && (
                <Route path="/widget-lab" exact component={WidgetLab} />
              )}

              {process.env.REACT_APP_MODE === 'Dev' && (
                <Route
                  path="/solution-capsules/internal"
                  exact
                  render={(props) => (
                    <SolutionCapsulesPage
                      internalPreview
                      autoLaunch={false}
                      {...props}
                    />
                  )}
                />
              )}
              {process.env.REACT_APP_MODE === 'Dev' && (
                <Route path="/solution-capsules" exact render={(props) => <SolutionCapsulesPage autoLaunch={false} {...props} />} />
              )}
              {/* Join-only target for shared scenario links. Gated with the lab
                  until the capsule routes are promoted. */}
              {process.env.REACT_APP_MODE === 'Dev' && (
                <Route path="/capsule-live" exact component={CapsuleLivePage} />
              )}
              {process.env.REACT_APP_MODE === 'Dev' && (
                <Route
                  path="/solution-capsules/agent-operations-lab"
                  exact
                  render={(props) => <SolutionCapsulesPage capsuleId="agent-operations-lab" autoLaunch={false} {...props} />}
                />
              )}
              {process.env.REACT_APP_MODE === 'Dev' && (
                <Route
                  path="/solution-capsules/click-to-call-service-desk"
                  exact
                  render={(props) => <SolutionCapsulesPage capsuleId="click-to-call-service-desk" autoLaunch={false} {...props} />}
                />
              )}

              <Route
                path="/ai-agents"
                exact
                render={() => <Redirect to="/aiagents" />}
              />
              <Route
                path="/aiagents"
                exact
                render={() => <AIAgentsStudioPublicPage username={username} />}
              />
              <Route path="/login" exact component={Login} />
              <Route path="/verify" exact component={Verify} />
              {/* {token ? (
              <Route path="/dashboard" exact component={Dashboard} />
            ) : (
              <Route path="/login" exact component={Login} />
            )} */}
              <Route path="/signup" exact component={Signup} />
              <Route path="/forgotPassword" exact component={ForgotPassword} />
              <Route path="/forgot-password" exact component={ForgotPassword} />
              
              
              {/* Meeting routes - full page without navigation */}
              <Route path="/meeting" exact render={(props) => <MeetingInterface {...props} startLoading={startLoading} stopLoading={stopLoading} />} />
              <Route path="/meeting/start" exact render={(props) => <MeetingInterface {...props} startLoading={startLoading} stopLoading={stopLoading} />} />
              <Route path="/meeting/notes" exact render={(props) => <MeetingInterface {...props} startLoading={startLoading} stopLoading={stopLoading} />} />
              <Route path="/meeting/join" exact render={(props) => <MeetingInterface {...props} startLoading={startLoading} stopLoading={stopLoading} />} />

              {/* Lite Subscription Checkout Page */}
              <Route path="/litesubscription" exact render={(props) => <LiteSubscriptionPage {...props} startLoading={startLoading} stopLoading={stopLoading} />} />
              
              {/* Lite Top-Up Credits Page */}
              <Route path="/litetopup" exact render={(props) => <TopUpPage {...props} startLoading={startLoading} stopLoading={stopLoading} />} />

              {/* LiteDashboard - Consumer-focused B2C dashboard (keep after specific /lite* routes) */}
              <Route path="/lite" render={(props) => <LiteDashboard {...props} startLoading={startLoading} stopLoading={stopLoading} />} />

              {/* AgentsDashboard - standalone AI agents workspace (peer of /lite and /dashboard) */}
              <Route path="/agents-dashboard" render={(props) => <AgentsDashboard {...props} startLoading={startLoading} stopLoading={stopLoading} />} />
              <Route path="/agentsdashboard" render={(props) => <AgentsDashboard {...props} startLoading={startLoading} stopLoading={stopLoading} />} />

              <Route path="/subscription" exact render = {(props) => <SubscriptionPage {...props} startLoading={startLoading} stopLoading={stopLoading} />} />
              <Route path="/payment" exact render = {(props) => <PaymentPage {...props} startLoading={startLoading} stopLoading={stopLoading} />} />
              <Route path="/purchase" exact render = {(props) => <Purchase {...props} startLoading={startLoading} stopLoading={stopLoading} />} />
              <Route path="/claim-benefits" exact render = {(props) => <ClaimBenefits {...props} startLoading={startLoading} stopLoading={stopLoading} />} />
              <Route path="/support" exact component={Support} />
              <Route path="/recording" exact render={(props) => <Recordings {...props} startLoading={startLoading} stopLoading={stopLoading}  />} />
              <Route path="/recordings" exact render={(props) => <Recordings {...props} startLoading={startLoading} stopLoading={stopLoading}  />} />
              <Route path="/ai-notes" exact render={(props) => <AINotesPublic {...props} startLoading={startLoading} stopLoading={stopLoading} />} />
              <Route path="/ainotes" exact render={(props) => <AINotesPublic {...props} startLoading={startLoading} stopLoading={stopLoading} />} />
              <Route path="/ai-notes-guide" exact component={AINotesGuide} />
              
              <Route path="/security" exact component={Security} />
              <Route path="/video-codecs" exact component={VideoCodecs} />
              <Route path="/scaling" exact component={Scaling} />
              <Route path="/recommended-settings" exact component={RecommendedSettings} />
              <Route path="/about" exact component={AboutUs} />
              <Route path="/careers" exact component={Careers} />
              <Route path="/contact" exact component={Support} />
              <Route path="/prebuilt" exact component={MediaSFUPrebuilt} />
              <Route path="/streaming" exact component={Streaming} />
              <Route path="/privacy-policy" exact component={PrivacyPolicy} />
              <Route path="/privacy" exact component={PrivacyPolicy} />
              <Route path="/terms-of-service" exact component={TermsOfService} />
              <Route path="/terms" exact component={TermsOfService} />
              <Route path="/api-keys" exact component={APIKeys} />
              <Route path="/cloud-recording" exact component={CloudRecording} />
              <Route path="/delete-account" exact component={DeleteAccount} />
              <Route path="/download" exact component={DownloadPage} />

              <Route path="/subscription-info" exact render={(props) => <SubscriptionInfo {...props} />} />


              <Route path="/docs" exact render={() => <NativeRouteRedirect to="/docs/" fallback="/documentation" />} />
              {/* Specific /docs/* routes must come BEFORE the generic catch-all below */}
              <Route path="/docs/sdk-headless-guide" exact render={() => <NativeRouteRedirect to="/docs/usage/headless/" fallback="/documentation" />} />
              <Route
                path="/docs/ai-method-runtime-override-reference"
                exact
                render={() => (
                  role === 'admin'
                    ? <AIMethodRuntimeOverrideReferencePage />
                    : <Redirect to={token ? '/dashboard' : '/login'} />
                )}
              />
              {/* Generic /docs/* catch-all: hands off to the static docs server.
                  The loop guard in NativeRouteRedirect prevents an infinite reload
                  when the server returns the React SPA instead of the docs site. */}
              <Route path="/docs/" render={({ location }) => <NativeRouteRedirect to={`${location.pathname}${location.search}${location.hash}`} fallback="/documentation" />} />
              <Route path="/storybook" exact render={() => <NativeRouteRedirect to="/storybook/" />} />
              <Route path="/storybook/" render={({ location }) => <NativeRouteRedirect to={`${location.pathname}${location.search}${location.hash}`} />} />
              <Route path="/docs-new/:docSlug" exact render={() => <NativeRouteRedirect to="/docs/guide-map/" />} />
              <Route path="/docs-new" exact render={() => <NativeRouteRedirect to="/docs/guide-map/" />} />
              <Route path="/guides" exact component={UserGuidesHub} />
              <Route path="/user-guide" exact render={(props) => <DashboardUserGuide WaitingModal={WaitingModal} {...props} />} />
              <Route path="/dashboard-guide" exact render={() => <NativeRouteRedirect to="/user-guide" />} />
              <Route path="/widget-studio-guide" exact component={WidgetStudioGuide} />
              <Route path="/documentation" exact component={DeveloperDocumentation} />
              <Route path="/developers" exact render={() => <NativeRouteRedirect to="/documentation" />} />
              <Route path="/sandbox" exact render={(props) => <Sandbox WaitingModal={WaitingModal} {...props} />} />
               <Route path="/basics" exact render={() => <NativeRouteRedirect to="/docs/usage/quickstart/" />} />
              <Route path="/components" exact render={() => <NativeRouteRedirect to="/docs/usage/storybook-visual-preview/" />} />
              <Route path="/agents" exact component={AIPipelineGuide} />
              <Route path="/gents" exact component={AIPipelineGuide} />
              <Route path="/telephony" exact component={SIPConfigGuide} />
              <Route path="/translation" exact render={(props) => <TranslationGuide WaitingModal={WaitingModal} {...props} />} />
              <Route path="/disposable-keys" exact component={DisposableKeysGuide} />
              <Route path="/widgets" exact component={WidgetsGuide} />
              <Route path="/campaigns" exact component={CampaignsGuide} />
              <Route path="/cheat-code" exact component={MediaSFUCheatSheet} />
              <Route path="/quick-usage" exact component={MediaSFUCheatSheet} />
              <Route path="/voice-agents" exact render={() => <TopicAuthorityPage topicId="voiceAgents" />} />
              <Route path="/webrtc-api" exact render={() => <WebRTCAuthorityPage pageId="hub" />} />
              <Route path="/webrtc-sfu-architecture" exact render={() => <WebRTCAuthorityPage pageId="architecture" />} />
              <Route path="/webrtc-scaling" exact render={() => <WebRTCAuthorityPage pageId="scaling" />} />
              <Route path="/managed-mediasoup" exact render={() => <WebRTCAuthorityPage pageId="managed" />} />
              <Route path="/sip-ai-agents" exact render={() => <TopicAuthorityPage topicId="sipAiAgents" />} />
              <Route path="/embeddable-call-widget" exact render={() => <TopicAuthorityPage topicId="embeddableCallWidget" />} />
              <Route path="/live-translation-api" exact render={() => <TopicAuthorityPage topicId="liveTranslationApi" />} />
              <Route path="/ai-meeting-notes" exact render={() => <TopicAuthorityPage topicId="aiMeetingNotes" />} />
              <Route path="/use-cases" exact component={UseCasesHubPage} />
              <Route path="/use-cases/sdk-showcase" exact component={SDKUseCaseShowcase} />
              <Route path="/use-cases/zero-code-ai-agents" exact component={ZeroCodeAIAgentsPage} />
              <Route path="/use-cases/live-voice-webinars" exact component={LiveVoiceWebinarPage} />
              <Route path="/case-studies" exact component={CaseStudiesHubPage} />
              <Route path="/case-studies/saas-support-automation" exact component={CaseStudySaaSSupportPage} />
              <Route path="/case-studies/multilingual-webinar-growth" exact component={CaseStudyMultilingualWebinarPage} />
              <Route path="/vs" exact component={VsHubPage} />
              <Route path="/vs/vapi" exact component={VsVapiPage} />
              <Route path="/vs/bland" exact component={VsBlandPage} />
              <Route path="/vs/retell" exact component={VsRetellPage} />
              <Route path="/vs/twilio" exact component={VsTwilioPage} />
              <Route path="/vs/agora" exact component={VsAgoraPage} />
              <Route path="/vs/daily" exact component={VsDailyPage} />
              <Route path="/vs/pipecat" exact component={VsPipecatPage} />
              <Route path="/vs/livekit" exact component={VsLivekitPage} />
              <Route path="/vs/vonage" exact component={VsVonagePage} />
              <Route path="/alternatives/:slug" exact component={AlternativesPage} />
              <Route path="/blog" exact component={BlogList} />
              <Route path="/blog/admin" exact component={BlogAdmin} />
              <Route path="/blog/admin/:action" exact component={BlogAdmin} />
              <Route path="/blog/admin/:action/:id" exact component={BlogAdmin} />
              <Route path="/blog/:legacyId/:legacySlug" exact component={BlogDetail} />
              <Route path="/blog/:slug" exact component={BlogDetail} />
              <Route path="/copilot" exact render={() => <ProductKnowledgeCopilotPage authenticated={Boolean(token)} />} />
              {/* Unmatched paths used to redirect silently to "/", which hid
                  typos and dead links from visitors and returned 200 for every
                  bad URL. Show a real not-found page instead. */}
              <Route component={NotFound} />
            </Switch>
       
          <div>
            <WaitingModal isActive={modalActive} />
          </div>
          </main>
          <ProductKnowledgeCopilotRoot authenticated={Boolean(token)} />
          {/* Conditionally render or hide the footer */}
        
        </authContext.Provider>
      </React.Fragment>
      </Suspense>
    </BrowserRouter>
    </HelmetProvider>
  );

}

export default App;
